





















/**
 * 홈 - 도서 - 연재 - 소개
 * 메뉴명: 연재 소개
 * 메뉴이름: BOOK_SERIES_DETAIL
 */
import { useRouter } from '@u3u/vue-hooks';
import { computed, defineComponent, ref } from '@vue/composition-api';

import { SerialDetailDTO, SerialEpisodeDTO } from '@/apis/repositories/types/serial';
import { fetchSerialDetail, fetchSerialEpisodeList } from '@/apis/services/serialService';
import { Breadcrumb, WPageWrapper, WTitle } from '@/components/base';
import Episodes from '@/components/views/book/Episodes.vue';
import LiteraryInfo from '@/components/views/book/LiteraryInfo.vue';
import logger from '@/modules/logger';

export default defineComponent({
  name: 'BookSeriesDetailPage',
  components: {
    Episodes,
    LiteraryInfo,
    Breadcrumb,
    WTitle,
    WPageWrapper,
  },
  setup() {
    const { route } = useRouter();
    const seriesInfo = ref<SerialDetailDTO | null>(null);
    const episodeList = ref<SerialEpisodeDTO[]>([]);
    const seriesId = computed(() => {
      return Number(route.value.params.seriesId);
    });

    const fetchSerieslDetail = async () => {
      try {
        seriesInfo.value = await fetchSerialDetail(seriesId.value);
      } catch (e) {
        logger.log('alpha', 'fetchSerieslDetail 실패', e);
        throw e;
      }
    };
    const fetchSeriesEpisodeList = async () => {
      try {
        episodeList.value = await fetchSerialEpisodeList(seriesId.value);
      } catch (e) {
        logger.log('alpha', 'fetchSeriesEpisodeList 실패', e);
        throw e;
      }
    };

    const fetchData = async () => {
      try {
        await Promise.all([fetchSerieslDetail(), fetchSeriesEpisodeList()]);
      } catch (e) {
        logger.log('alpha', '연재 상세 보기 첫 화면 구성 실패', e);
      }
    };

    return { fetchData, seriesId, seriesInfo, episodeList };
  },
});
